/**
 * Fetch child comments (replies to `parentId`) for a given roadmap item.
 * Mirrors Flutter RoadmapRepository.getComments(roadmapItemId, parentId, ...)
 * (lib/presentation/bottom_sheet/roadmap_comments_bottom_sheet.dart:301-402).
 */

import {
  RoadmapCommentService,
  type RoadmapCommentsPage,
} from '@/domain/services/roadmapComment/roadmapCommentService';
import { SERVER_FETCH_CONSTANTS } from '@/domain/constants/serverFetchConstants';
import type { PageCursor } from '@/data/types/json';

export class FetchRoadmapChildCommentsUseCase {
  constructor(private service = RoadmapCommentService.getInstance()) {}

  async execute(
    roadmapItemId: string,
    parentId: string,
    cursor?: PageCursor,
    limit: number = SERVER_FETCH_CONSTANTS.COMMENT_CHILDREN_PAGINATION,
  ): Promise<RoadmapCommentsPage> {
    return this.service.fetchComments(roadmapItemId, parentId, limit, cursor);
  }
}

export const fetchRoadmapChildCommentsUseCase = new FetchRoadmapChildCommentsUseCase();
